<div class="container">
  <h1 class="page-title"
    [helpCenterButton]="viewPermissionCode" [lang]="currentLang"
    [helpCenterDownloadButton]="viewPermissionCode" [position]="'inline'" [lang]="currentLang">
    <span class="icon"><i class="fas fa-tags" aria-hidden="true"></i></span>{{ 'HubLabelSetup.Header' | translate}}
  </h1>

  <p-card>
    <p-accordion>
      <p-accordionTab header="{{ 'Common.Form.Header' | translate}}" [(selected)]="isSearchFormOpen">
        <!-------------------------------------- Query Form ---------------------------------------------->
        <form [formGroup]="searchForm" (ngSubmit)="searchBtnClick()">
          <div class="grid formgrid p-fluid">
            <div class="col-6 field">
              <label for="orgId">{{ 'HubLabelSetup.Form.ORGId' | translate}}</label>
              <input id="orgId" type="text" maxlength="50" pInputText formControlName="orgId" />
            </div>
            <div class="col-6 field">
              <label for="hubVendorCode">{{ 'HubLabelSetup.Form.HubVendorCode' | translate}}</label>
              <input id="hubVendorCode" type="text" maxlength="50" pInputText formControlName="hubVendorCode" />
            </div>
            <div class="col-6 field">
              <label for="custSku">{{ 'HubLabelSetup.Form.CustSku' | translate}}</label>
              <input id="custSku" type="text" maxlength="100" pInputText formControlName="custSku" />
            </div>
            <div class="col-6 field">
              <label for="labelKey">{{ 'HubLabelSetup.Form.LabelKey' | translate}}</label>
              <input id="labelKey" type="text" maxlength="50" pInputText formControlName="labelKey" />
              <small>{{ 'HubLabelSetup.Form.LabelKeyNote' | translate }}</small>
            </div>
          </div>
          <div>
            <button
              pButton
              label="{{ 'Common.Button.Search' | translate }}"
              type="submit">
            </button>
            <button
              pButton
              label="{{ 'Common.Button.Reset' | translate }}"
              type="reset"
              class="p-button-secondary ml-2">
            </button>
          </div>
        </form>
      </p-accordionTab>
    </p-accordion>

    <!-------------------------------------- Table ---------------------------------------------->
    <p-table
      #dataTable
      [columns]="selectedColumns"
      [value]="tableData"
      [loading]="isLoading"
      [reorderableColumns]="true"
      [resizableColumns]="true"

      [scrollable]="true"
      scrollHeight="500px"
      scrollDirection="both"

      [(selection)]= "selectedRow"
      selectionMode="single"

      [lazy]="true"
      (onPage)="pageChange($event)"
      (onSort)="tableSorting($event)"
      [resetPageOnSort]="false"

      [paginator]="true"
      [showCurrentPageReport]="true"
      currentPageReportTemplate="{{ 'Common.Table.PageSummary' | translate }}"
      [rows]="this.pageInfo.pageSize"
      [rowsPerPageOptions]="[5, 10, 20]"
      [totalRecords]="this.pageInfo.totalRecords"

      class="editTable"
      dataKey="dataKey"
      editMode="row"
      styleClass="datatable-gridlines datatable-striped mt-2 white-space: nowrap;">

      <ng-template pTemplate="caption">
        <laas-table-column-toggle
          [optionsColumn]="tableColumns"
          [dataTable]="dataTable">
        </laas-table-column-toggle>
        <button
          pButton
          type="button"
          label="{{ 'Common.Button.Add' | translate}}"
          icon="fas fa-plus"
          [disabled]="!isInEditMode"
          (click)="addNewRow()"
          class="p-button-success p-button-raised ml-2"
        ></button>
        <button
          pButton
          type="button"
          label="{{ 'Common.Button.Delete' | translate}}"
          icon="fas fa-trash-alt"
          [disabled]="!isInEditMode"
          (click)="deleteSelectedRow()"
          class="p-button-danger p-button-raised ml-2"
        ></button>
        <button
          pButton
          type="button"
          label="{{ 'Common.Button.Save' | translate}}"
          icon="fas fa-save"
          [disabled]="!isInEditMode"
          (click)="saveChanges()"
          class="p-button-raised ml-2"
        ></button>
        <button
          pButton
          type="button"
          label="{{ 'HubLabelSetup.Button.Restore' | translate }}"
          icon="fas fa-sync-alt"
          [disabled]="!isInEditMode"
          (click)="restoreTableData()"
          class="p-button-secondary p-button-raised ml-2"
        ></button>
        <button
          pButton
          type="button"
          label="{{ isInEditMode ? ( 'Common.Button.Cancel' | translate ) : ( 'Common.Button.Edit' | translate ) }}"
          icon="fas fa-pen"
          (click)="switchEditMode()"
          class="p-button-warning p-button-raised ml-2"
          style="color: white"
        ></button>
      </ng-template>

      <ng-template pTemplate="colgroup" let-columns>
        <colgroup>
          <col *ngFor="let col of columns" style="width: 14.8vw" />
        </colgroup>
      </ng-template>

      <!------------------------------------------ Table Header --------------------------------------------------->
      <ng-template pTemplate="header" let-columns>
        <tr>
          <th
            scope="col"
            [pSortableColumn]="col.field"
            [pSortableColumnDisabled]="!col.sort"
            *ngFor="let col of columns"
            pResizableColumn
            pReorderableColumn
          >
            {{ col.header | translate }}
            <p-sortIcon [field]="col.field"></p-sortIcon>
          </th>
        </tr>
      </ng-template>

      <!------------------------------------------ Table Content --------------------------------------------------->
      <ng-template
        pTemplate="body"
        let-rowData
        let-columns="columns">

        <tr [pSelectableRow]="rowData" [pEditableRow]="rowData" (click)="onRowSelect(rowData)">
          <td *ngFor="let col of columns">
            <ng-container [ngSwitch]="col.field">

              <!------------------------------------------ Org ID columns --------------------------------------------------->
              <p-cellEditor *ngSwitchCase="'orgId'" class="p-fluid">
                <ng-template pTemplate="input">
                  <input
                    id="tableOrgId"
                    type="text"
                    maxlength="50"
                    [(ngModel)]="rowData[col.field]"
                    required
                    pInputText
                  />
                  <small *ngIf="!rowData[col.field]" class="alert">
                    <div class="p-invalid">
                      {{ 'HubLabelSetup.Warning.OrgIdRequired' | translate }}
                    </div>
                  </small>
                </ng-template>
                <ng-template pTemplate="output">
                  <div class="overflow-text">{{ rowData[col.field] | replaceNullWith:'-'}}</div>
                </ng-template>
              </p-cellEditor>

              <!------------------------------------------ Hub Vendor Code columns --------------------------------------------------->
              <p-cellEditor *ngSwitchCase="'hubVendorCode'" class="p-fluid">
                <ng-template pTemplate="input">
                  <input
                    id="tableHubVendorCode"
                    type="text"
                    maxlength="50"
                    [(ngModel)]="rowData[col.field]"
                    required
                    pInputText
                  />
                  <small *ngIf="!rowData[col.field]" class="alert">
                    <div class="p-invalid">
                      {{ 'HubLabelSetup.Warning.HubVendorCodeRequired' | translate }}
                    </div>
                  </small>
                </ng-template>
                <ng-template pTemplate="output">
                  <div class="overflow-text">{{ rowData[col.field] | replaceNullWith:'-'}}</div>
                </ng-template>
              </p-cellEditor>

              <!------------------------------------------ Cust Sku columns --------------------------------------------------->
              <p-cellEditor *ngSwitchCase="'custSku'" class="p-fluid">
                <ng-template pTemplate="input">
                  <input
                    id="tableCustSku"
                    type="text"
                    maxlength="100"
                    [(ngModel)]="rowData[col.field]"
                    required
                    pInputText
                  />
                  <small *ngIf="!rowData[col.field]" class="alert">
                    <div class="p-invalid">
                      {{ 'HubLabelSetup.Warning.CustSkuRequired' | translate }}
                    </div>
                  </small>
                </ng-template>
                <ng-template pTemplate="output">
                  <div class="overflow-text">{{ rowData[col.field] | replaceNullWith:'-'}}</div>
                </ng-template>
              </p-cellEditor>

              <!------------------------------------------ Label Key columns --------------------------------------------------->
              <p-cellEditor *ngSwitchCase="'labelKey'" class="p-fluid">
                <ng-template pTemplate="input">
                  <input
                    id="tableLabelKey"
                    type="text"
                    maxlength="50"
                    [(ngModel)]="rowData[col.field]"
                    required
                    pInputText
                  />
                  <small  class="alert">
                    <div *ngIf="!rowData[col.field] else tableLabelKey" class="p-invalid">
                      {{ 'HubLabelSetup.Warning.LabelKeyRequired' | translate }}
                    </div>
                    <ng-template #tableLabelKey>
                      <div class="p-invalid">
                        <ng-container *ngIf="!checkLabelKeyIsInRightFormat(rowData[col.field])">
                          {{ 'HubLabelSetup.Warning.LabelKeyMustOnlyHavePositiveInteger' | translate }}
                        </ng-container>
                      </div>

                    </ng-template>
                  </small>
                </ng-template>
                <ng-template pTemplate="output">
                  <div class="overflow-text">{{ rowData[col.field] | replaceNullWith:'-'}}</div>
                </ng-template>
              </p-cellEditor>

              <!------------------------------------------ Created By columns --------------------------------------------------->
              <td *ngSwitchCase="'createdBy'" class="p-fluid">
                <div class="overflow-text">
                  {{rowData[col.field] | replaceNullWith:'-'}}
                </div>
              </td>

              <!------------------------------------------ Creation Date columns --------------------------------------------------->
              <td *ngSwitchCase="'creationDate'" class="p-fluid">
                <div class="overflow-text">
                  {{rowData[col.field] | date:'YYYY-MM-dd HH:mm:ss':this.laasSetting.facilityTimeZone | replaceNullWith:'-'}}
                </div>
              </td>

              <!------------------------------------------ Last Updated By columns --------------------------------------------------->
              <td *ngSwitchCase="'lastUpdatedBy'" class="p-fluid">
                <div class="overflow-text">
                  {{rowData[col.field] | replaceNullWith:'-'}}
                </div>
              </td>

              <!------------------------------------------ Last Update Date columns --------------------------------------------------->
              <td *ngSwitchCase="'lastUpdateDate'" class="p-fluid">
                <div class="overflow-text">
                  {{rowData[col.field] | date:'YYYY-MM-dd HH:mm:ss':this.laasSetting.facilityTimeZone | replaceNullWith:'-'}}
                </div>
              </td>

              <!------------------------------------------ Hub Label Setup ID columns --------------------------------------------------->
              <td *ngSwitchCase="'hubLabelSetupId'" class="p-fluid">
                <div class="overflow-text">
                  {{rowData[col.field] | replaceNullWith:'-'}}
                </div>
              </td>

            </ng-container>
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td [attr.colspan]="tableColumns.length">
            {{ "Common.Table.NoData" | translate }}
          </td>
        </tr>
      </ng-template>
    </p-table>
  </p-card>
</div>
<help-dock
  [permissionCode]="viewPermissionCode"
  [lang]="currentLang">
</help-dock>
